import { all, call, put, takeLatest } from "redux-saga/effects";
import { StatusCodes } from "http-status-codes";
import { request } from "src/utils/api";
import notification from "antd/es/notification";
import { FETCH_TABLE_STATEMENT, UPDATE_PAID_OWNER } from "../actions/VehicleMasterAction";
import {
  fetchVehicleMasterFailure,
  fetchVehicleMasterSuccess,
  updatePaidOwnerFailure,
  updatePaidOwnerSuccess,
} from "../slices/VehicleMasterSlice";

export function* fetchVehicleMasterSaga(
  action: any
): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) {
      const payload = result.data || result;
      yield put(fetchVehicleMasterSuccess(payload));
    } else {
      yield put(fetchVehicleMasterFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchVehicleMasterFailure(error.message));
  }
}

export function* updatePaidOwnerSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    // if (result.status >= 200 && result.status < 300)
    if (result.status == StatusCodes.OK) {
      yield put(updatePaidOwnerSuccess(result.data));
      notification.success({
        message: "Update success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(updatePaidOwnerFailure(result.message));
      notification.error({
        message: "Update Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(updatePaidOwnerFailure(error));
  }
}

export default function* vehicleMasterSaga() {
  yield all([
    takeLatest(FETCH_TABLE_STATEMENT, fetchVehicleMasterSaga),
    takeLatest(UPDATE_PAID_OWNER, updatePaidOwnerSaga),
  ]);
}
